// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__J5AI-","table":"styles_table__1bunM"};